// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal {
  position: absolute;
  bottom: -150vh;
  width: 90vw;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  transition: bottom 0.5s ease-in-out;
  z-index: 10;
  border-radius: 7px;
  border: solid;
  border-color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  /* width: 100%; */
}

.modal-x-container {
  width: 99%;
  text-align: end;
  font-weight: 600;
}

.bg {
  position: fixed;
  z-index: 1040;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.233);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
}

.Modal.how-to-play {
  height: 95%;
  width: 95%;
  bottom: 2.5%;
  border: none;
}

.Modal.confirmation-modal {
  bottom: 40%;
  max-width: 500px;
  background-color: ghostwhite;
}

.Modal.set-password {
  height: 70%;
  bottom: 20%;
  width: 90%;
  background-color: rgba(211, 209, 197, 0.938);
}

.Modal.how-to-play.disappear {
  bottom: -150vh;
}

.Modal.login {
  background-color: rgba(211, 209, 197, 0.938);
  max-height: 400px;
  min-height: 320px;
  max-width: 400px;
}
@media (min-height: 400px) {
  .Modal.login {
    bottom: 10%;
  }
}

@media (min-height: 600px) {
  .Modal.login {
    bottom: 20%;
  }
}

@media (min-height: 700px) {
  .Modal.login {
    bottom: 30%;
  }
}

@media (min-height: 800px) {
  .Modal.login {
    bottom: 40%;
  }
}

.Modal.login.disappear {
  bottom: -150vh;
}

.Modal.winner {
  background-color: rgb(230, 225, 225);
  max-height: 98%;
  width: 90%;
  max-width: 500px;
}

@media (max-width: 400px) {
  .Modal.create-account {
    max-width: 350px;
  }
}

.Modal.create-account {
  background-color: rgb(230, 225, 225);
  max-height: 98%;
  width: 90%;
  max-width: 500px;
}

@media (max-width: 400px) {
  .Modal.create-account {
    max-width: 350px;
  }
}

.Modal.puzzle-genie-login {
  background-color: rgb(230, 225, 225);
  max-height: 98%;
  width: 90%;
  max-width: 500px;
}

.Modal.update-username.show {
  background-color: rgb(230, 225, 225);
  max-height: 400px;
  width: 90%;
  bottom: 30%;
}

.Modal.winner.show {
  top: 1%;
  bottom: unset;
}

.Modal.create-account.show {
  top: 5%;
  bottom: unset;
}

.Modal.puzzle-genie-login.show {
  top: 5%;
  bottom: unset;
}

.Modal.hamburger-menu {
  transition: left 0.5s ease-in-out;
  margin-left: 0px;
  max-width: 300px;
  height: 98%;
  bottom: 0.5vh;
  left: -200vw;
  background-color: ghostwhite;
  /* background-color: rgba(211, 209, 197, 0.938); */
  display: flex;
}

.Modal.get-newsie-plus {
  max-height: 90%;
  bottom: 10%;
  width: 90%;
  background-color: rgb(248, 248, 255);
}

.Modal.hamburger-menu.show {
  left: 0vw;
}

.Modal.hamburger-menu.disappear {
  left: -200vw;
}

.Modal.newsie-categories {
  background-color: rgb(252, 248, 248);
  width: 80%;
  height: 70%;
  bottom: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Modal.loading {
  background-color: rgb(252, 248, 248);
  opacity: 0.5;
  width: 80%;
  height: 70%;
  bottom: 20%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB","sourcesContent":[".Modal {\n  position: absolute;\n  bottom: -150vh;\n  width: 90vw;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  transition: bottom 0.5s ease-in-out;\n  z-index: 10;\n  border-radius: 7px;\n  border: solid;\n  border-color: rgba(0, 0, 0, 0.589);\n  display: flex;\n  flex-direction: column;\n  /* width: 100%; */\n}\n\n.modal-x-container {\n  width: 99%;\n  text-align: end;\n  font-weight: 600;\n}\n\n.bg {\n  position: fixed;\n  z-index: 1040;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.233);\n  backdrop-filter: blur(3px);\n}\n\n.Modal.how-to-play {\n  height: 95%;\n  width: 95%;\n  bottom: 2.5%;\n  border: none;\n}\n\n.Modal.confirmation-modal {\n  bottom: 40%;\n  max-width: 500px;\n  background-color: ghostwhite;\n}\n\n.Modal.set-password {\n  height: 70%;\n  bottom: 20%;\n  width: 90%;\n  background-color: rgba(211, 209, 197, 0.938);\n}\n\n.Modal.how-to-play.disappear {\n  bottom: -150vh;\n}\n\n.Modal.login {\n  background-color: rgba(211, 209, 197, 0.938);\n  max-height: 400px;\n  min-height: 320px;\n  max-width: 400px;\n}\n@media (min-height: 400px) {\n  .Modal.login {\n    bottom: 10%;\n  }\n}\n\n@media (min-height: 600px) {\n  .Modal.login {\n    bottom: 20%;\n  }\n}\n\n@media (min-height: 700px) {\n  .Modal.login {\n    bottom: 30%;\n  }\n}\n\n@media (min-height: 800px) {\n  .Modal.login {\n    bottom: 40%;\n  }\n}\n\n.Modal.login.disappear {\n  bottom: -150vh;\n}\n\n.Modal.winner {\n  background-color: rgb(230, 225, 225);\n  max-height: 98%;\n  width: 90%;\n  max-width: 500px;\n}\n\n@media (max-width: 400px) {\n  .Modal.create-account {\n    max-width: 350px;\n  }\n}\n\n.Modal.create-account {\n  background-color: rgb(230, 225, 225);\n  max-height: 98%;\n  width: 90%;\n  max-width: 500px;\n}\n\n@media (max-width: 400px) {\n  .Modal.create-account {\n    max-width: 350px;\n  }\n}\n\n.Modal.puzzle-genie-login {\n  background-color: rgb(230, 225, 225);\n  max-height: 98%;\n  width: 90%;\n  max-width: 500px;\n}\n\n.Modal.update-username.show {\n  background-color: rgb(230, 225, 225);\n  max-height: 400px;\n  width: 90%;\n  bottom: 30%;\n}\n\n.Modal.winner.show {\n  top: 1%;\n  bottom: unset;\n}\n\n.Modal.create-account.show {\n  top: 5%;\n  bottom: unset;\n}\n\n.Modal.puzzle-genie-login.show {\n  top: 5%;\n  bottom: unset;\n}\n\n.Modal.hamburger-menu {\n  transition: left 0.5s ease-in-out;\n  margin-left: 0px;\n  max-width: 300px;\n  height: 98%;\n  bottom: 0.5vh;\n  left: -200vw;\n  background-color: ghostwhite;\n  /* background-color: rgba(211, 209, 197, 0.938); */\n  display: flex;\n}\n\n.Modal.get-newsie-plus {\n  max-height: 90%;\n  bottom: 10%;\n  width: 90%;\n  background-color: rgb(248, 248, 255);\n}\n\n.Modal.hamburger-menu.show {\n  left: 0vw;\n}\n\n.Modal.hamburger-menu.disappear {\n  left: -200vw;\n}\n\n.Modal.newsie-categories {\n  background-color: rgb(252, 248, 248);\n  width: 80%;\n  height: 70%;\n  bottom: 20%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.Modal.loading {\n  background-color: rgb(252, 248, 248);\n  opacity: 0.5;\n  width: 80%;\n  height: 70%;\n  bottom: 20%;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
